module.exports = __webpack_public_path__ + "static/media/default-app.137be88d.svg";